// ToDo: Reduce RAM by hashing the keys

const SEPARATOR = '/' // A unique char which is unlikely to appear in data/env pathes or nodeid

export const createDataKey = (dataPath: Array<string>) => 'd' + SEPARATOR + dataPath.join(SEPARATOR)
export const createEnvKey = (envPath: Array<string>) => 'e' + SEPARATOR + envPath.join(SEPARATOR)
export const createNodeKey = (compId: string, nodeId: string) => 'n' + SEPARATOR + compId + SEPARATOR + nodeId
